import React from 'react';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import PageCanvas from '../components/ui/PageCanvas';
import PageHeader from '../components/ui/PageHeader';
import Panel from '../components/ui/Panel';
import ActionButton from '../components/ui/ActionButton';

const RapidApplicationDev = () => {
  return (
    <PageCanvas>
      <PageHeader
        title="Rapid Application Development"
        subtitle="Auto-generate React frontend and Java API endpoints from an input master table."
      />

      <Panel title="External Application Access">
        <div className="flex items-center justify-between gap-4">
          <p className="text-textSecondary" style={{ fontSize: '0.875rem' }}>
            Access external development tools and resources to enhance your rapid application development
            workflow.
          </p>
          <a href="https://beeonixrappdev.bigtapp.net/" target="_blank" rel="noreferrer">
            <ActionButton variant="primary" endIcon={ArrowTopRightOnSquareIcon}>
              Navigate to External App
            </ActionButton>
          </a>
        </div>
      </Panel>
    </PageCanvas>
  );
};

export default RapidApplicationDev;
